import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "@/contexts/AuthContext";
import { useIdleLogout } from "@/hooks/useIdleLogout";

const IDLE_LOGOUT_MINUTES = 15;

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  useIdleLogout(IDLE_LOGOUT_MINUTES, async () => {
    await logout();
    toast.info("You were signed out after 15 minutes of inactivity");
    navigate("/login", { replace: true });
  });

  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar collapsed={collapsed} />
      <div className="flex-1 flex flex-col min-w-0">
        <Header onToggleSidebar={() => setCollapsed((c) => !c)} />
        <main className="flex-1 p-6 md:p-8 animate-fade-in">
          <Outlet />
        </main>
        <Footer />
      </div>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}
